import { Link } from 'react-router-dom';
import { Button } from '@/components/ui';
import { routePaths } from './routes';

export function NotFoundPage() {
  return (
    <div className="grid min-h-dvh place-items-center px-4 text-center">
      <div>
        <p className="text-5xl font-extrabold text-primary">404</p>
        <p className="mt-2 text-ink-mute">Pagina căutată nu există.</p>
        <Link to={routePaths.home} className="mt-6 inline-block">
          <Button variant="primary">Înapoi la pagina principală</Button>
        </Link>
      </div>
    </div>
  );
}
